module.exports = __webpack_public_path__ + "img/p-logo.e323eeb4343900e6fd731743bceb7bf8.png";